// Mockup-only toast. Non-functional buttons call showToast("Would do X in
// the real app") so staff never see a tap go nowhere. Delete when the
// real app ships.

import { useEffect, useState } from "react";

type ToastEntry = { id: number; text: string };

let nextId = 1;
const listeners = new Set<(entries: ToastEntry[]) => void>();
let entries: ToastEntry[] = [];

function emit() {
  for (const l of listeners) l([...entries]);
}

export function showToast(text: string) {
  const entry = { id: nextId++, text };
  entries = [...entries, entry];
  emit();
  setTimeout(() => {
    entries = entries.filter((e) => e.id !== entry.id);
    emit();
  }, 2200);
}

export function ToastHost() {
  const [current, setCurrent] = useState<ToastEntry[]>([]);
  useEffect(() => {
    listeners.add(setCurrent);
    return () => {
      listeners.delete(setCurrent);
    };
  }, []);

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex flex-col gap-2 pointer-events-none">
      {current.map((t) => (
        <div
          key={t.id}
          className="bg-slate-900/95 backdrop-blur text-white text-sm px-4 py-2.5 rounded-full shadow-lg animate-in fade-in"
        >
          {t.text}
        </div>
      ))}
    </div>
  );
}
